import { memo, useEffect } from "react";
import { CheckboxProps, Grid, Radio } from "semantic-ui-react";

type IPVersionProps = {
  onChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps,
  ) => void;
  ipVersion: number;
};

const IPVersion = ({ onChange, ipVersion }: IPVersionProps) => {
  useEffect(() => {
    // Simulating an event for onChange to set the default value as 4
    onChange(
      {} as React.FormEvent<HTMLInputElement>,
      { name: "ipVersion", value: 4, checked: true } as CheckboxProps,
    );
  }, [onChange]);

  return (
    <Grid.Row>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <h5>IP Version</h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={4}>
        <Radio
          className="simple-radio"
          label="IPv4"
          name="ipVersion"
          value={4}
          checked={ipVersion === 4}
          onChange={onChange}
        />
      </Grid.Column>
      <Grid.Column textAlign="left" width={4}>
        <Radio
          className="simple-radio"
          label="IPv6"
          name="ipVersion"
          value={6}
          checked={ipVersion === 6}
          onChange={onChange}
        />
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(IPVersion);
